import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { QueryContextSettingID } from 'src/app/services/query-context/models/IQueryContext';
import {
    QueryContextChange,
    QueryContextService,
} from 'src/app/services/query-context/query-context.service';

export interface IStringInputQueryContextSettingDashboardItem {
    id: QueryContextSettingID;
    viewtype: 'string-input';
    displayName: string;
    /** Current value */
    value?: string | undefined;
}

@Component({
    selector: 'app-string-input-setting',
    templateUrl: './string-input-setting.component.html',
    styleUrls: ['./string-input-setting.component.scss'],
})
export class StringInputSettingComponent implements OnInit {
    @Input()
    options!: IStringInputQueryContextSettingDashboardItem;

    dataModelValue: string | undefined = undefined;

    constructor(
        private queryContextService: QueryContextService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.dataModelValue = this.options.value;
        this.queryContextService.appliedQueryContextEmitter.subscribe(
            this.queryContextSubscriber
        );
    }

    onViewModelChange(value: string | undefined) {
        // value is already set to this.dataModelValue
        // this.dataModelValue = value;

        this.queryContextService.changePendingQueryContext({
            setting: { id: this.options.id, value: this.dataModelValue },
        });
    }

    queryContextSubscriber = (contextChange: QueryContextChange) => {
        if (contextChange.reason === 'InitialContext') {
            // if option id in contextChange.context.settings
            // then set value from contextChange.context.settings
            const setting = contextChange.context.settings[this.options.id];
            if (setting) {
                this.dataModelValue = setting as string;
                this.cd.detectChanges();
            }
        }
    };
}
